import React from "react";
import Header from "../../components/layout/Header";
import BottomBar from "../../components/staxs/BottomBar";
import { HiBolt } from "react-icons/hi2";

const MintPage: React.FC = () => {
  return (
    <div className="w-full pt-16 min-h-screen">
      <Header />
      <div className="container max-w-2xl mx-auto py-8 pb-0 px-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-base-content font-grotesk">
              Mint
            </h1>
            <p className="text-sm text-base-content/70">
              Discover and mint new sports moments
            </p>
          </div>
          <div className="flex items-center gap-2 bg-neutral text-neutral-content px-3 py-2 rounded-lg">
            <HiBolt className="w-4 h-4" />
            <span className="text-sm font-medium">Live</span>
          </div>
        </div>

        {/* Digital Collectable */}
        <div className="bg-base-100 rounded-2xl shadow-sm mb-6">
          <div className="p-6 border-b border-base-200">
            <div className="gap-2">
              <h3 className="text-2xl font-semibold font-grotesk text-base-content">
                <span className="font-light">Mint</span> Digital Collectable
              </h3>
              <p className="text-sm">
                Sporting Moment that is tradable on the STAXS Marketplace
              </p>
            </div>
          </div>
        </div>

        {/* Aggregate Data Pools */}
        <div className="bg-base-100 rounded-2xl shadow-sm mb-6">
          <div className="p-6 border-b border-base-200">
            <div className="gap-2">
              <h3 className="text-2xl font-semibold font-grotesk text-base-content">
                <span className="font-light">Mint</span> Sports Data
              </h3>
              <p className="text-sm">
                Tokenise your PEAK data and contribute to aggregate data pools.
                Earn for the sale of your data.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom spacing for fixed bottom bar */}
        <div className="h-24"></div>
      </div>

      {/* STAX Bottom Navigation Bar */}
      <BottomBar />
    </div>
  );
};

export default MintPage;
